module.exports = __webpack_public_path__ + "static/img/8.966ff84.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/zh/8.png
// module id = jjzc
// module chunks = 0